import * as React from 'react'
import PopoverWithClipboardCopy from '../components/PopoverWithClipboardCopy'
import { Box, Icon, styled } from '@design/pt-ui'
import { Contact } from '../interfaces/entities/contact'

const ContactIcon = styled(Icon)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  fontSize: '1.1rem',
}))

interface IContactProps {
  contact: Contact
}

function ContactComponent(props: IContactProps) {
  const { contact } = props

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <span>{contact.name}</span>

      {contact.phone && (
        <PopoverWithClipboardCopy
          activator={<ContactIcon>phone</ContactIcon>}
          value={contact.phone}>
          {contact.phone}
        </PopoverWithClipboardCopy>
      )}
      {contact.email && (
        <PopoverWithClipboardCopy
          activator={<ContactIcon>email</ContactIcon>}
          value={contact.email}>
          {contact.email}
        </PopoverWithClipboardCopy>
      )}
    </Box>
  )
}

export default ContactComponent
